const IvoryCoastSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111658)">
      <path
        d="M20.0004 40C22.4468 40 24.7903 39.56 26.9569 38.756L27.8265 20L26.957 1.24398C24.7903 0.440078 22.4468 0 20.0004 0C17.554 0 15.2105 0.440078 13.0439 1.24398L12.1743 20L13.0438 38.756C15.2105 39.56 17.554 40 20.0004 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M0 20.0011C0 28.6004 5.4275 35.9313 13.0435 38.7571V1.24512C5.4275 4.07098 0 11.4018 0 20.0011Z"
        fill="#FF9811"
      />
      <path
        d="M26.9565 1.24512V38.7572C34.5726 35.9313 40.0001 28.6004 40.0001 20.0011C40.0001 11.4018 34.5726 4.07098 26.9565 1.24512Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111658">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IvoryCoastSvg;
